import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=be89d9ec&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user_center.css?vue&type=style&index=0&id=be89d9ec&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be89d9ec",
  null
  
)

export default component.exports